const locale = {
	// #region Contracts fields
	DETAILS_CONTRACTS_FIELD_TITLE: 'Titolo',
	DETAILS_CONTRACTS_FIELD_STATUS: 'Stato Contratto',
	DETAILS_CONTRACTS_FIELD_TYPE: 'Tipo Contratto',
	DETAILS_CONTRACTS_FIELD_COMPANY: 'Cliente',
	DETAILS_CONTRACTS_FIELD_PERSON: 'Referente esterno',
	DETAILS_CONTRACTS_FIELD_ASSIGNED_USER: 'Utente assegnato interno',
	DETAILS_CONTRACTS_FIELD_ASSIGNED_USER_2: 'Utente assegnato esterno',
	DETAILS_CONTRACTS_FIELD_DATE_FROM: 'Data inizio',
	DETAILS_CONTRACTS_FIELD_DATE_TO: 'Data fine',
	DETAILS_CONTRACTS_FIELD_SIGNDATE: 'Data firma',
	DETAILS_CONTRACTS_FIELD_RATING: 'Valutazione',
	DETAILS_CONTRACTS_FIELD_VALUE_FIXED: 'Valore fisso',
	DETAILS_CONTRACTS_FIELD_VALUE_PERCENTAGE: 'Percentuale',
	DETAILS_CONTRACTS_FIELD_EXPENSES: 'Spese',
	DETAILS_CONTRACTS_FIELD_TAGS: 'Tag',
	DETAILS_CONTRACTS_FIELD_WARNING: 'Warning',
	DETAILS_CONTRACTS_FIELD_BLOCKED: 'Bloccato',
	// #endregion

	// #region Contracts Lines
	CONTRACTS_LINES_FOOTER_TOT_AMOUNT: 'Importo totale: {value}',

	DETAILS_CONTRACTS_LINES_FIELD_BILLING_DATE: 'Data emissione',
	DETAILS_CONTRACTS_LINES_FIELD_AMOUNT: 'Importo',
	DETAILS_CONTRACTS_LINES_FIELD_DESCRIPTION: 'Descrizione',
	DETAILS_CONTRACTS_LINES_FIELD_BILLED: 'Fatturato',
	DETAILS_CONTRACTS_LINES_FIELD_INVOICE: 'Numero Fattura',
	DETAILS_CONTRACTS_LINES_FIELD_DATE_BILLED: 'Data Fattura',

	DETAILS_CONTRACTS_LINES_BUTTON_EDIT_LINES: 'Modifica righe',
	DETAILS_CONTRACTS_LINES_BUTTON_ADD_ITEM: 'Aggiungi riga',
	DETAILS_CONTRACTS_LINES_BUTTON_DELETE_LINES: 'Rimuovi righe',

	DIALOG_CONTRACTS_LINES_DIALOG_ADD_TITLE: 'Aggiungi riga',
	DIALOG_CONTRACTS_LINES_DIALOG_EDIT_TITLE: 'Modifica riga'
	// #endregion
};

export default locale;
